function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.regexp.exec.js";
import { getIsKlarnaSite } from 'framework/utils/core/siteUtils';
import { styleAttributes } from '../components/customStyle/customStyleUtils';
import { getWidgetBaseUrl } from '../components/utils/constants';
const categoryProps = {
    productLimit: undefined,
    categoryId: undefined,
    merchantIds: undefined
};
const productProps = {
    onlyInStock: true,
    offerOrigin: 'NATIONAL',
    offerLimit: undefined,
    productId: undefined
};
const bestPriceProps = {
    productId: undefined
};
const singleProductProps = {
    productId: undefined
};
const productsProps = {
    productIds: [],
    onlyInStock: true
};
const widgetProps = {
    ['CATEGORY']: categoryProps,
    ['PRODUCT']: productProps,
    ['BESTPRICE']: bestPriceProps,
    ['SINGLEPRODUCT']: singleProductProps,
    ['PRODUCTS']: productsProps
};
export function getCustomizedText(widgetType) {
    switch(widgetType){
        case 'PRODUCT':
        case 'BESTPRICE':
        case 'SINGLEPRODUCT':
            return 'PR.PublisherWidgets.CUSTOMIZE_TEXT_PRODUCT';
        case 'PRODUCTS':
            return 'PR.PublisherWidgets.CUSTOMIZE_TEXT_PRODUCTS';
        case 'CATEGORY':
            return 'PR.PublisherWidgets.CUSTOMIZE_TEXT_CATEGORY';
        default:
            return '';
    }
}
export function getTypeSpecificValues(widgetType) {
    const productsValues = {
        errorLabel: 'PR.PublisherWidgets.CHOOSE_ITEM_PRODUCT',
        placeholder: 'PR.PublisherWidgets.PRODUCT_NAME'
    };
    switch(widgetType){
        case 'CATEGORY':
            return {
                id: 'categoryId',
                suggestionType: 'CATEGORY',
                errorLabel: 'PR.PublisherWidgets.CHOOSE_ITEM_CATEGORY',
                placeholder: 'PR.PublisherWidgets.CATEGORY_NAME',
                limitId: 'productLimit',
                limitLabel: 'PR.PublisherWidgets.CHOOSE_LIMIT_PRODUCTS',
                limitPlaceHolder: 'PR.PublisherWidgets.PRODUCT_LIMIT',
                limitTooltip: 'PR.PublisherWidgets.PRODUCT_TOOLTIP'
            };
        case 'PRODUCTS':
            return _object_spread_props(_object_spread({}, productsValues), {
                id: 'productIds',
                suggestionType: 'PRODUCTS'
            });
        default:
            return _object_spread_props(_object_spread({}, productsValues), {
                id: 'productId',
                limitId: 'offerLimit',
                limitLabel: 'PR.PublisherWidgets.CHOOSE_LIMIT_OFFERS',
                limitPlaceHolder: 'PR.PublisherWidgets.OFFER_LIMIT',
                limitTooltip: 'PR.PublisherWidgets.OFFER_TOOLTIP',
                suggestionType: 'PRODUCT'
            });
    }
}
export function getInitialState(widgetType, params = {}) {
    if (widgetType === undefined) {
        return {};
    }
    const stateForType = widgetProps[widgetType];
    const initialState = _object_spread_props(_object_spread({}, stateForType), {
        partnerId: undefined
    });
    const applicableParams = Object.keys(initialState);
    const newParams = Object.keys(params).reduce((object, key)=>{
        if (applicableParams.includes(key)) {
            object[key] = params === null || params === void 0 ? void 0 : params[key];
        }
        return object;
    }, {});
    return _object_spread({}, initialState, newParams);
}
function getIdentifierParams(params, widgetType) {
    switch(widgetType){
        case 'BESTPRICE':
            return params.productId;
        case 'PRODUCT':
            return params.productId;
        case 'SINGLEPRODUCT':
            return params.productId;
        case 'PRODUCTS':
            var _params_productIds;
            return params === null || params === void 0 ? void 0 : (_params_productIds = params.productIds) === null || _params_productIds === void 0 ? void 0 : _params_productIds.join('-');
        case 'CATEGORY':
            return params.categoryId;
        default:
            return '';
    }
}
export const getWidgetIdString = (params, widgetType, id)=>{
    const identifierParams = getIdentifierParams(params, widgetType);
    if (!identifierParams) {
        return undefined;
    }
    return `pr-${widgetType.toLowerCase()}-widget-${id}`;
};
const getExcludedParams = (params)=>{
    return styleAttributes.filter((style)=>params[style.name] === style.defaultValue).map((param)=>param.name);
};
export const getWidgetPreviewUrl = (params, countryCode, widgetType, serviceStage, id)=>{
    const type = widgetType.toLowerCase();
    const allParams = Object.assign({}, params, {
        widgetId: id
    });
    const excludedDefaultParams = getExcludedParams(allParams);
    const urlParams = Object.keys(allParams).filter((key)=>allParams[key] !== undefined).filter((key)=>allParams[key] !== null).filter((key)=>!excludedDefaultParams.includes(key)).filter((key)=>key !== undefined).map((key)=>`${key}=${encodeURIComponent(allParams[key])}`).join('&');
    const extension = '.js';
    const baseUrl = getWidgetBaseUrl(serviceStage);
    const url = `${[
        baseUrl,
        countryCode.toLowerCase(),
        `${type}${extension}`
    ].filter(Boolean).join('/')}?${urlParams}`;
    return url;
};
export const productLimitOptions = Array.from(new Array(5), (_, index)=>`${index + 1}`);
export function getWidgetEmbedCode(url, logo, widgetId) {
    const showFooter = getIsKlarnaSite() === false;
    return `
    <div id="${widgetId}" style="display: block; width: 100%"></div>
    <script type="text/javascript" src="${url}" async></script>
    ${showFooter ? logo : ''}
    `.trim();
}
export function getWidgetEmbedLogo(text, url, color) {
    return `
    <div style="display: inline-block">
      <a href="${url}" rel="nofollow">
        <p
          style="font: 14px 'Klarna Text', Helvetica, sans-serif; font-style: italic; color: ${color}; text-decoration: underline;">
             ${text} <span style="font-weight:bold">PriceRunner</span>
        </p>
      </a>
    </div>
  `.trim();
}
export const singleProductWidgetOptions = [
    {
        type: 'PRODUCT',
        heading: 'PR.PublisherWidgets.PRODUCT',
        description: 'PR.PublisherWidgets.PRODUCT_DESCRIPTION'
    },
    {
        type: 'SINGLEPRODUCT',
        heading: 'PR.PublisherWidgets.SINGLE_PRODUCT',
        description: 'PR.PublisherWidgets.SINGLE_PRODUCT_DESCRIPTION'
    },
    {
        type: 'BESTPRICE',
        heading: 'PR.PublisherWidgets.BEST_PRICE',
        description: 'PR.PublisherWidgets.BEST_PRICE_DESCRIPTION'
    }
];
export const multipleProductWidgetOptions = [
    {
        type: 'PRODUCTS',
        heading: 'PR.PublisherWidgets.PRODUCTS',
        description: 'PR.PublisherWidgets.PRODUCTS_DESCRIPTION'
    },
    {
        type: 'CATEGORY',
        heading: 'PR.PublisherWidgets.CATEGORY',
        description: 'PR.PublisherWidgets.CATEGORY_DESCRIPTION'
    }
];
export const validationSchema = {
    CATEGORY: {
        categoryId: /\d/,
        productLimit: /\d/
    },
    PRODUCT: {
        offerLimit: /\d/,
        productId: /\d/
    },
    BESTPRICE: {
        productId: /\d/
    },
    SINGLEPRODUCT: {
        productId: /\d/
    },
    PRODUCTS: {
        productIds: /\d/
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function validateForm(state, validation) {
    const isInvalid = (validationKey)=>{
        const match = validation[validationKey].test(state[validationKey]);
        return match === false;
    };
    const validationKeys = Object.keys(validation);
    const invalidFields = validationKeys.filter(isInvalid);
    return invalidFields;
}
